/** returns internacional corporate process list
@return { Array }
*/
export const getProcessesList = state => state.processesList
export const getProcessesListHasMore = state => state.processesListHasMore

/** returns international transfers currencies list
@return { Array }
*/
export const getTmxCurrencyList = state => state.tmxCurrencyList

/** returns international transfers estimated amount
@return { Object }
*/
export const getTmxEstimatedAmount = state => state.tmxEstimatedAmount
